export default __webpack_public_path__ + "static/media/sharat.4ad44d79.jpg";